// extracted by mini-css-extract-plugin
module.exports = {"list":"pagenav_list__O8Nk7","item":"pagenav_item__Q6yWP"};